// eslint-disable-next-line no-restricted-imports
import { NotifyMessageFragment } from 'api/generated/graphql';
import { lodash } from 'helpers';
import { useNotify } from 'libs/notify';

const getNotifyType = (type: string) => {
  switch (type) {
    case 'Error':
      return 'error';
    default:
      return 'info';
  }
};

export const useNotifyMessages = () => {
  const notify = useNotify();

  return (messages: (NotifyMessageFragment | null)[] | null | undefined) => {
    setTimeout(() =>
      lodash.compact(messages).forEach((message) => {
        notify.show(getNotifyType(message.type), message.text);
      })
    );
  };
};
